import {
  FlightMoreData,
  LeagueSeasonGuestView,
  LeagueSeasonParticipantView,
  LeagueSeasonTeam,
  PlayerInFlightData,
  CompetitionPlayDistribution,
  LeagueLeaderboardItem,
  LeagueSeasonPrize,
  LeagueSeasonSponsor,
  LeagueSeasonCompetitionView,
} from './../../data/mygolf.data';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { BehaviorSubject, filter, map, Observable, Subscription, take, finalize } from 'rxjs';
import { ClubFlightService } from 'services/club-flight-service/club-flight-service';
import { SessionInfo } from 'src/data/authentication-info';
import {
  LeagueSeason,
  LeagueSeasonPlayer,
  PlayerHomeInfo,
  PlayerInfo,
  TournamentPlayerBasicView,
} from 'src/data/mygolf.data';
import * as globals from 'src/globals';
import { PlayerHomeActions, PlayerHomeDataService } from 'src/redux/player-home';
import { SessionActions, SessionDataService } from 'src/redux/session';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { LoadingController } from '@ionic/angular';
import { AppCustomizerService } from 'services/app-customizer-service/app-customizer.service';

import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class MultiCourseCompetitionService implements OnDestroy {
  /**
   * behaviourSubjects for
   * clubId
   * clubInfo
   * organizerId
   * leagueId
   * seasonId
   * isQueryParam
   * selClubMembership
   * homeClubMembership
   * isClubSpecific: boolean
   * clubSpecificSelected
   *  */
  appClient: string = globals?.appClient?.toLowerCase();
  currentPlayerDetails: PlayerInfo;
  currentPlayerId: number = 0;
  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;
  constructor(
    private flightService: ClubFlightService,
    private router: Router,
    private playerHomeService: PlayerHomeDataService,
    private sessionService: SessionDataService,
    private playerHomeActions: PlayerHomeActions,
    private sessionActions: SessionActions,
    private mg2uUtils: mygolfUtils,
    private loadingCtl: LoadingController,
    private customizerService: AppCustomizerService
  ) {
    sessionActions.onLogout$.subscribe(() => this.cleanupSubscriptions());
    this.playerHomeActions.setNeedRefresh(true);
    // this.subPlayerHomeInfo =

    if (!globals.appClient?.length && this.subCustAttribute) {
      this.subCustAttribute.unsubscribe();
      this.subCustAttribute = null;
    }
    this.playerHomeService.playerHomeInfo().subscribe((playerHome: PlayerHomeInfo) => {
      console.debug('[init customizer] season player home [info]', playerHome);
      if (playerHome?.player) {
        this.currentPlayerDetails = playerHome?.player ?? null;
        this.sessionService
          .getSession()
          .pipe(take(1))
          .subscribe((session: SessionInfo) => {
            this.currentPlayerId = session?.playerId;
            console.debug('[init customizer] current player [session]', session);
          });
        this.refreshCustomizedAttributes(true);
      } else {
        this.currentPlayerDetails = null;
        this.setSeasonDetails(null);
        this.setRosterDetails(null);
        this.refreshCustomizedAttributes(true);
      }
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

      this.player$ = this.playerHomeInfo$.pipe(filter(Boolean)).pipe(
        map((playerHome: any) => {
          return playerHome;
        })
      );
    });
  }

  subPlayerHomeInfo: Subscription;

  // load customized-attributes locally or from server
  // redirect url/page method
  /***
   * setClubSpecific
   * setClubId
   * isQueryParam
   * setPersistClubTheme - 'communal' | String(clubId) | null for clearing
   * setSearchCompetition - can be for clubId, organizerId, partOfLeague
   * setSearchTeeBookings
   * setClubMembership
   * setHomeClub
   * changeTheme - reads clubSpecificThemes
   *  -> updateColor(themeName, reset?)
   * goToHomepage
   * goToProfile
   * goToSignUp
   */
  /**
   * customized pages :
   * sign-in
   * sign-up
   * player-home
   * profile
   * competition-filter
   * tabs.page (footer)
   * index (splash logo/animation-lottie)
   */

  subCustAttribute: Subscription;
  customizedAttributes = new BehaviorSubject({
    menuItems: [],
    scoringEnabled: false,
    moreMenu: {
      show: false,
    },
    menuRows: 3,
    promotions: {
      show: false,
    },
    snpPackages: {
      show: false,
    },
    news: {
      show: false,
    },
    topLogoUrl1: null,
    topLogoUrl2: null,
    membership: {},
    leagueSeasons: {},
    footerItems: [],
  });

  currentSeasonId: number = 0; // = new BehaviorSubject<number>(0);
  nextSeasonId: number = 0; // = new BehaviorSubject<number>(0);
  refreshCustomizedAttributes(currentSeason: boolean = false) {
    console.debug('refreshCustomizedAttributes', globals.appClient);
    if (this.subCustAttribute) return;

    this.subCustAttribute = this.flightService.getCustomizedAttributes(true, false).subscribe(
      (data: any) => {
        if (data) {
          this.localAttributes = data;
          console.debug('customized attributes', data);
          // this.setCurrentSeason(Number(data?.leagueSeasons?.currentSeason?.seasonId));
          if (!currentSeason) {
            this.currentSeasonId = Number(data?.leagueSeasons?.currentSeason?.seasonId);
            this.nextSeasonId = Number(data?.leagueSeasons?.nextSeason?.seasonId);
          }
          this.refreshSeasonDetails();
          this.setCustomizedAttributes(data);
        }
        if (this.subCustAttribute) {
          this.subCustAttribute.unsubscribe();
          this.subCustAttribute = null;
        }
      },
      error => {
        if (this.subCustAttribute) {
          this.subCustAttribute.unsubscribe();
          this.subCustAttribute = null;
        }
      }
    );
  }

  localAttributes: any;

  setCustomizedAttributes(data) {
    this.customizedAttributes.next(data);
  }

  getCustomizedAttributes() {
    return this.customizedAttributes.asObservable();
  }

  goToPlayerHome() {
    this.customizerService.goToPlayerHome();
    // console.debug('go to player home', this.appClient);
    // if (globals?.appType === 'club' && globals?.appClient?.length) {
    //   this.router.navigate([`/tabs/${this.appClient}-player-home`], { replaceUrl: true });
    // } else {
    //   this.router.navigate(['/tabs/player-home'], { replaceUrl: true });
    // }
  }
  goToPlayerProfile(params: NavigationExtras) {
    this.customizerService.goToPlayerProfile(params);
    // console.debug('go to player profile', this.appClient);
    // this.router.navigate([`/tabs/${this.appClient}-profile`], params);
  }

  redirectHomePage() {
    this.customizerService.goToPlayerHome();
    // if (globals?.appType === 'club' && globals?.appClient?.length) {
    //   return `${this.appClient}-player-home`;
    // } else {
    //   return '/tabs/player-home';
    // }
  }

  refreshSeasonDetails() {
    // this.currentSeasonId.subscribe((seasonId) => {
    console.debug('season details ', this.currentSeasonId);
    this.flightService
      .getSingleLeagueSeason(this.currentSeasonId)
      .subscribe((season: LeagueSeason) => {
        console.debug('season details ', season, this.currentPlayerDetails);
        this.setSeasonDetails(season);

        if (season?.leagueSettings?.hideLeaderBoard !== undefined) {
          this.setHideLeaderboard(season?.leagueSettings?.hideLeaderBoard);
        }
        setTimeout(() => {
          this.refreshRosterDetails();
          this.refreshPlayerFlightSchedules();
          this.refreshPrizes();
          this.refreshParticipatingClubs();
          this.refreshPlayerActiveRound();
          this.getRounds();
        }, 500);
      });
    // })
  }

  leagueSeasonDetails: BehaviorSubject<LeagueSeason> = new BehaviorSubject<LeagueSeason>(
    null
  ) as BehaviorSubject<LeagueSeason>;
  getSeasonDetails() {
    return this.leagueSeasonDetails.asObservable();
  }

  setSeasonDetails(season: LeagueSeason) {
    this.leagueSeasonDetails.next(season);
  }

  seasonRosterDetails: BehaviorSubject<TournamentPlayerBasicView & LeagueSeasonGuestView> =
    new BehaviorSubject<LeagueSeasonPlayer>(null) as BehaviorSubject<
      TournamentPlayerBasicView & LeagueSeasonGuestView
    >;
  currentPlayerRosterDetails: TournamentPlayerBasicView & LeagueSeasonGuestView = null;
  refreshRosterDetails(organizerId?: number, seasonId?: number) {
    const playerId = this.currentPlayerDetails?.playerId; // || this.currentPlayerId;
    const _organizer = organizerId || globals?.organizerId;
    const _seasonId = seasonId || this.currentSeasonId;
    this.flightService
      .getMultiCoursePlayerDetails(_organizer, _seasonId, playerId)
      // .getSeasonRosterPlayerDetails(this.currentSeasonId, playerId)
      .subscribe(
        (rosterDetails: TournamentPlayerBasicView & LeagueSeasonGuestView) => {
          console.debug('roster details ', rosterDetails);
          if (rosterDetails) {
            this.currentPlayerRosterDetails = rosterDetails;
            this.setRosterDetails(rosterDetails);
          } else {
            this.currentPlayerRosterDetails = null;
            this.setRosterDetails(null);
          }
        },
        error => {
          console.debug('error roster details : ', error);
          this.currentPlayerRosterDetails = null;
          this.setRosterDetails(null);
          if (error?.toLowerCase().includes('playernotfound')) {
            this.refreshGuestDetails(_organizer, _seasonId);
          }
        }
      );
  }

  refreshGuestDetails(organizerId?: number, seasonId?: number) {
    const playerId = this.currentPlayerDetails?.playerId; // || this.currentPlayerId;
    const _organizer = organizerId || globals?.organizerId;
    const _seasonId = seasonId || this.currentSeasonId;
    this.flightService
      .getMultiCourseGuestDetails(_organizer, _seasonId, playerId)
      // .getSeasonRosterPlayerDetails(this.currentSeasonId, playerId)
      .subscribe(
        (rosterDetails: TournamentPlayerBasicView & LeagueSeasonGuestView) => {
          console.debug('roster details ', rosterDetails);
          if (rosterDetails) {
            this.currentPlayerRosterDetails = rosterDetails;
            this.setRosterDetails(rosterDetails);
          } else {
            this.currentPlayerRosterDetails = null;
            this.setRosterDetails(null);
          }
        },
        error => {
          console.debug('error guest details : ', error);
          this.currentPlayerRosterDetails = null;
          this.setRosterDetails(null);
        }
      );
  }

  getRosterDetails() {
    return this.seasonRosterDetails.asObservable();
  }

  setRosterDetails(rosterDetails: TournamentPlayerBasicView & LeagueSeasonGuestView) {
    this.seasonRosterDetails.next(rosterDetails);
  }

  getRosterInfo(attribute: string) {
    if (!this.currentPlayerRosterDetails) return;
    const rosterDetails: TournamentPlayerBasicView & LeagueSeasonGuestView =
      this.currentPlayerRosterDetails;
    if (!this.currentPlayerRosterDetails && attribute === 'groupColor') {
      return 'transparent';
    }
    if (!this.currentPlayerRosterDetails && attribute === 'participantType') {
      return 'Visitor';
    }
    switch (attribute) {
      case 'stream':
        return rosterDetails?.competitionStream?.name;
      case 'category':
        return rosterDetails?.competitionPlayerCategory?.name;
      case 'groupColor':
        return rosterDetails?.playerGroup?.groupColor;
      case 'groupName':
        return rosterDetails?.playerGroup?.name;
      case 'playerImage':
        if (!rosterDetails?.player?.image) {
          if (rosterDetails?.player?.gender === 'M') return 'assets/image/homeImg/male_golfer.png';
          else if (rosterDetails?.player?.gender === 'F')
            return 'assets/image/homeImg/female_golfer.png';
        }
        return rosterDetails?.player?.image;
      case 'handicapIndex':
        return rosterDetails?.initialHandicapIndex || rosterDetails?.handicapIndex;
      case 'initialHandicapIndex':
        return rosterDetails?.initialHandicapIndex;
      case 'playerName':
        return rosterDetails?.player?.playerName;
      case 'playerId':
        return rosterDetails?.player?.id;
      case 'teamName':
        return rosterDetails?.teamName;
      case 'isCaptain':
        return rosterDetails?.captain;
      case 'isRegistered':
        return rosterDetails;
      case 'details':
        return rosterDetails;
      case 'isValidInfo':
        return rosterDetails?.validInfo;
      case 'isApproved':
        return rosterDetails?.approved;

      case 'participantType':
        const _length = rosterDetails?.participantType?.length;
        const _participantType =
          rosterDetails?.participantType[0] +
          rosterDetails?.participantType?.substring(1, _length)?.toLowerCase();
        return _participantType; // rosterDetails?.participantType;
    }
  }

  ngOnDestroy() {
    this.cleanupSubscriptions();
    this.setSeasonDetails(null);
    this.setRosterDetails(null);
    this.setCustomizedAttributes(null);
    this.currentPlayerDetails = null;
  }

  public cleanupSubscriptions() {
    if (this.subCustAttribute) {
      this.subCustAttribute.unsubscribe();
      this.subCustAttribute = null;
    }
    if (this.subPlayerHomeInfo) {
      this.subPlayerHomeInfo.unsubscribe();
      this.subPlayerHomeInfo = null;
    }
  }

  multiCourseId: BehaviorSubject<number> = new BehaviorSubject<number>(
    0
  ) as BehaviorSubject<number>;
  currentOrganizerId: number;
  currentMultiCourseId: number;
  getMultiCourseId() {
    return this.multiCourseId.asObservable();
  }
  setMultiCourseId(id: number) {
    this.multiCourseId.next(id);
  }

  multiCourseDetails: BehaviorSubject<LeagueSeason> = new BehaviorSubject<LeagueSeason>(
    null
  ) as BehaviorSubject<LeagueSeason>;
  currentMultiCourseDetails: LeagueSeason;
  getMultiCourseDetails() {
    return this.multiCourseDetails.asObservable();
  }

  setMultiCourseDetails(season: LeagueSeason) {
    this.multiCourseDetails.next(season);
  }

  playersList: BehaviorSubject<Array<TournamentPlayerBasicView>> = new BehaviorSubject<
    Array<TournamentPlayerBasicView>
  >(null);
  getPlayersList() {
    return this.playersList.asObservable();
  }

  setPlayersList(playersList: Array<TournamentPlayerBasicView>) {
    this.playersList.next(playersList);
  }

  guestsList: BehaviorSubject<Array<LeagueSeasonGuestView>> = new BehaviorSubject<
    Array<LeagueSeasonGuestView>
  >(null);

  getGuestsList() {
    return this.guestsList.asObservable();
  }

  setGuestsList(guestsList: Array<LeagueSeasonGuestView>) {
    this.guestsList.next(guestsList);
  }

  participantsList: BehaviorSubject<Array<LeagueSeasonParticipantView>> = new BehaviorSubject<
    Array<LeagueSeasonParticipantView>
  >(null);

  getParticipantsList() {
    return this.participantsList.asObservable();
  }

  setParticipantsList(participantsList: Array<LeagueSeasonParticipantView>) {
    this.participantsList.next(participantsList);
  }

  refreshCompetitionDetails(orgId?: number, multiCourseId?: number) {
    if (orgId) this.currentOrganizerId = orgId;
    if (multiCourseId) this.currentMultiCourseId = multiCourseId;
    this.flightService
      .getMultiCourseDetails(this.currentOrganizerId, this.currentMultiCourseId)
      .subscribe(data => {
        if (data) {
          this.setMultiCourseDetails(data);
          this.currentMultiCourseDetails = data;
          this.currentOrganizerId = data?.league?.organizer?.id;
          this.currentMultiCourseId = data?.id;
          if (data?.leagueSettings?.hideLeaderBoard !== undefined) {
            this.setHideLeaderboard(data?.leagueSettings?.hideLeaderBoard);
          }

          setTimeout(() => {
            this.refreshPlayersList();
            this.refreshGuestsList();
            this.refreshParticipantsList();
          }, 500);
        }
      });
  }

  refreshPlayersList() {
    const organizerId = this.currentOrganizerId;
    const seasonId = this.currentSeasonId;
    this.flightService.getMultiCoursePlayersList(organizerId, this.currentMultiCourseId).subscribe(
      (playersList: Array<TournamentPlayerBasicView>) => {
        if (playersList) {
          this.setPlayersList(playersList);
        } else {
          this.setPlayersList(null);
        }
      },
      error => {
        this.setPlayersList(null);
        if (error?.toLowerCase().includes('playernotfound')) {
          this.refreshGuestDetails(organizerId, seasonId);
        }
      }
    );
  }

  refreshGuestsList() {
    const organizerId = this.currentOrganizerId;
    this.flightService.getMultiCourseGuestsList(organizerId, this.currentMultiCourseId).subscribe(
      (guestsList: Array<LeagueSeasonGuestView>) => {
        if (guestsList) {
          this.setGuestsList(guestsList);
        } else {
          this.setGuestsList(null);
        }
      },
      error => {
        this.setGuestsList(null);
      }
    );
  }

  refreshParticipantsList() {
    const organizerId = this.currentOrganizerId;
    this.flightService
      .getMultiCourseParticipantsList(organizerId, this.currentMultiCourseId)
      .subscribe(
        (participantsList: Array<LeagueSeasonParticipantView>) => {
          if (participantsList) {
            this.setParticipantsList(participantsList);
          } else {
            this.setParticipantsList(null);
          }
        },
        error => {
          this.setParticipantsList(null);
        }
      );
  }

  refreshTeamPlayersList() {
    let _orgId = this.currentOrganizerId;
    let _seasonId = this.currentMultiCourseId;
    this.flightService
      .getMultiCourseCompTeamPlayers(_orgId, _seasonId)
      .subscribe((teamPlayers: any) => {
        console.debug('team players list : ', teamPlayers);
        if (teamPlayers) {
          this.constructTeamPlayers(teamPlayers);
        }
      });
  }

  mergedTeamsList: BehaviorSubject<Array<LeagueSeasonTeam & any>> = new BehaviorSubject<
    Array<LeagueSeasonTeam & any>
  >(null);
  getMergedTeamsList() {
    return this.mergedTeamsList.asObservable();
  }

  setMergedTeamsList(mergedTeamsList: Array<LeagueSeasonTeam & any>) {
    this.mergedTeamsList.next(mergedTeamsList);
  }

  constructTeamPlayers(teamPlayers: any) {
    const filteredCompTeams: LeagueSeasonTeam & any = this.currentMultiCourseDetails?.teams;
    filteredCompTeams?.sort((a, b) => a.teamName.toLowerCase().localeCompare(b.teamName));
    filteredCompTeams.forEach(team => {
      if (team?.teamPlayers === undefined) team.teamPlayers = [];
      team.teamPlayers = teamPlayers.filter(tp => {
        return tp?.teamId === team?.id;
      });
      if (team?.teamPlayers?.length) {
        this.getPlayersList().subscribe((playersList: Array<TournamentPlayerBasicView>) => {
          if (playersList?.length)
            playersList.forEach(mp => {
              team?.teamPlayers?.find(tp => {
                if (tp?.player?.id === mp?.playerId) {
                  if (tp?.compDetails === undefined) tp.compDetails = {};
                  tp.compDetails = mp;
                }
                // console.debug('construct team players - mp / tp : ', mp, tp);
              });
            });
          this.setMergedTeamsList(filteredCompTeams);
        });
      }
    });
  }

  flightSessions: Array<any> = [];
  mergedFlights: Array<FlightMoreData> = [];
  checkCompFlights(myFlightMode: boolean = false, overrideLeagueSeason?: LeagueSeason) {
    console.debug('[debug] check comp flights', myFlightMode, this.currentMultiCourseDetails);
    return new Promise((resolve, reject) => {
      if (overrideLeagueSeason) this.currentMultiCourseDetails = overrideLeagueSeason;
      if (!this.currentMultiCourseDetails) return;
      this.myFlightMode = myFlightMode;
      this.currentMultiCourseDetails.seasonCompetitions.forEach(lsc => {
        this.getCompFlights(lsc?.competition?.id);
      });

      let _playDist: CompetitionPlayDistribution = null;
      if (this.currentMultiCourseDetails?.playDistribution) {
        _playDist = this.currentMultiCourseDetails?.playDistribution;
      } else if (this.currentMultiCourseDetails?.playDistributionStr?.length > 0) {
        _playDist = JSON.parse(this.currentMultiCourseDetails?.playDistributionStr);
      }
      setTimeout(() => {
        if (this.mergedFlights?.length) {
          this.flightSessions = this.constructSessionGroup(this.mergedFlights);
          this.flightSessions.sort((a, b) => {
            if (a.roundSessionDate < b.roundSessionDate) return -1;
            else if (a.roundSessionDate > b.roundSessionDate) return 1;
            else {
              if (a.sessionTime < b.sessionTime) return -1;
              if (a.sessionTime > b.sessionTime) return 1;
              else return 0;
            }
          });
        }
        this.combinePlayerScheduleFlights();
        setTimeout(() => {
          console.debug('check comp flights : ', this.mergedFlights, _playDist);
          if (this.mergedFlights?.length) {
            resolve({ success: true, page: 'flights' });
          } else if (_playDist?.schedules?.length) {
            resolve({ success: true, page: 'schedules' });
          } else reject(false);
        }, 250);
      }, 500);
    });
  }

  myFlightMode: boolean = false;
  filteredFlight: Array<any> = [];
  flights: Array<any> = [];
  getCompFlights(compId?: number) {
    const _currentRound = 1;
    let _compId = compId;
    this.flightService.getCompFlightList(_compId, _currentRound).subscribe(flights => {
      console.debug(`comp flight data [${_compId}] :`, flights);
      if (flights) {
        let _player;
        this.player$.pipe(take(1)).subscribe(player => {
          _player = player;
        });
        flights.forEach((f: FlightMoreData) => {
          let _playerFlight = f.flightMembers.filter((fm: PlayerInFlightData) => {
            if (_player) return fm.player.playerId === _player.playerId;
          });
          if (_playerFlight?.length > 0) f.playerFlight = true;
        });
        if (this.myFlightMode) {
          flights = flights.filter((f: FlightMoreData) => {
            return f?.playerFlight;
          });
          this.mergedFlights.push(...flights);
          // this.flightSessions.push(...this.constructSessionGroup(this.mergedFlights));
          // this.flightSessions = this.constructSessionGroup();
        } else {
          this.flights = flights;
          this.filteredFlight = this.flights;
          this.flightSessions = this.constructSessionGroup(this.flights);
        }
      }
    });
  }

  playerFlightSchedules: Array<any> = [];
  refreshPlayerFlightSchedules() {
    let _orgId = this.currentMultiCourseDetails?.league?.organizer?.id;
    let _seasonId = this.currentMultiCourseDetails?.id;
    let _player;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    this.flightService
      .getMultiCourseFlightSchedulesByPlayer(_orgId, _seasonId, _player?.playerId)
      .subscribe((flights: Array<any>) => {
        console.debug('get multi course flight schedules by player : ', flights);
        this.playerFlightSchedules = flights;
      });
  }

  combinePlayerScheduleFlights() {
    if (!this.playerFlightSchedules || this.playerFlightSchedules.length === 0) return;
    if (!this.mergedFlights || this.mergedFlights.length === 0) return;
    this.mergedFlights.sort((a, b) => {
      if (a.roundSessionDate < b.roundSessionDate) return -1;
      else if (a.roundSessionDate > b.roundSessionDate) return 1;
      else {
        if (a.sessionTime < b.sessionTime) return -1;
        if (a.sessionTime > b.sessionTime) return 1;
        else return 0;
      }
    });
    this.mergedFlights.forEach((f: FlightMoreData) => {
      if (!f.scheduleDetails) f.scheduleDetails = null;
      this.playerFlightSchedules.forEach((psf: FlightMoreData) => {
        if (f?.gameRound?.id === psf?.gameRound?.id) {
          f.scheduleDetails = psf;
        }
      });
    });
    console.debug('my flight mode', this.mergedFlights);
    // if(!this.player)
  }

  constructSessionGroup(flights) {
    let _flights = flights; //this.flights;
    // if (this.myFlightMode) _flights = this.mergedFlights;
    const _sessions = _flights.map((f: FlightMoreData) => {
      return {
        roundSessionDate: f.roundSessionDate,
        sessionTime: f.sessionTime,
        roundSessionId: f.roundSessionId,
        roundSessionSequence: f.roundSessionSequence,
      };
    });
    return this.mg2uUtils.getUnique(_sessions, 'roundSessionId');
  }

  /***
   * @param scoreType(string)
   * @param streamId(number)
   * @param categoryId(number)
   */
  async refreshLeaderboard(seasonId: number, params?: any) {
    let loader = await this.loadingCtl.create({ message: 'Please wait...' });
    loader.present();
    let _params = params;
    this.flightService
      .getMultiCourseIndividualLeaderboard(this.currentMultiCourseId || seasonId, _params)
      .pipe(
        finalize(() => {
          if (loader) loader.dismiss();
        })
      )
      .subscribe(data => {
        this.setIndividualLeaderboard(data);
      });
  }

  individualLeaderboard: BehaviorSubject<Array<LeagueLeaderboardItem>> = new BehaviorSubject<
    Array<LeagueLeaderboardItem>
  >([]);
  getIndividualLeaderboard() {
    return this.individualLeaderboard.asObservable();
  }

  setIndividualLeaderboard(leaderboard: Array<LeagueLeaderboardItem>) {
    this.individualLeaderboard.next(leaderboard);
  }

  setCurrentSeasonId(seasonId: number) {
    this.currentSeasonId = seasonId;
  }

  needRefreshMCTDetails: BehaviorSubject<boolean> = new BehaviorSubject(false);
  getRefreshMCTDetails() {
    return this.needRefreshMCTDetails.asObservable();
  }
  setRefreshMCTDetails(value: boolean) {
    this.needRefreshMCTDetails.next(value);
  }

  refreshPlayerTravelInfo(multiCourseCompId: number, playerId: number) {
    this.flightService.getMCTPlayerTravelInfo(multiCourseCompId, playerId).subscribe(
      playerTravelInfo => {
        if (playerTravelInfo) {
          this.setPlayerTravelInfo(playerTravelInfo);
        } else {
          this.setPlayerTravelInfo(null);
        }
      },
      error => {
        this.setPlayerTravelInfo(null);
      }
    );
  }

  playerTravelInfo: BehaviorSubject<any> = new BehaviorSubject({});
  setPlayerTravelInfo(data) {
    this.playerTravelInfo.next(data);
  }

  getPlayerTravelInfo() {
    return this.playerTravelInfo.asObservable();
  }

  selectedTravelHotelRoom: BehaviorSubject<any> = new BehaviorSubject({});
  setSelectedHotelRoom(hotelRoom: any) {
    this.selectedTravelHotelRoom.next(hotelRoom);
  }

  getSelectedHotelRoom() {
    return this.selectedTravelHotelRoom.asObservable();
  }

  refreshPrizes(multiCompId?: number) {
    const mctId = multiCompId || this.currentSeasonId;
    this.flightService.getMCTPrizes(mctId).subscribe(
      (prizesList: LeagueSeasonPrize[]) => {
        console.debug('get mct prizes: ', prizesList);
        if (prizesList?.length) this.setPrizes(prizesList);
        else this.setPrizes(null);
      },
      error => {
        this.setPrizes(null);
      }
    );
  }

  setPrizes(value: any) {
    this.mctPrizes.next(value);
  }
  getPrizes() {
    return this.mctPrizes.asObservable();
  }

  mctPrizes: BehaviorSubject<any> = new BehaviorSubject(null);

  hideLeaderboard: BehaviorSubject<boolean> = new BehaviorSubject(null);
  getHideLeaderboard() {
    return this.hideLeaderboard.asObservable();
  }

  setHideLeaderboard(value) {
    return this.hideLeaderboard.next(value);
  }

  mctSponsors: BehaviorSubject<any> = new BehaviorSubject(null);
  refreshSponsors(multiCompId?: number) {
    const mctId = multiCompId || this.currentSeasonId;
    this.flightService.getMCTSponsors(mctId).subscribe(
      (sponsorsList: LeagueSeasonSponsor[]) => {
        console.debug('get mct Sponsors: ', sponsorsList);
        if (sponsorsList?.length) this.setSponsors(sponsorsList);
        else this.setSponsors(null);
      },
      error => {
        this.setSponsors(null);
      }
    );
  }

  setSponsors(value: any) {
    this.mctSponsors.next(value);
  }
  getSponsors() {
    return this.mctSponsors.asObservable();
  }

  addSponsorClickCount(sponsorId: number, multiCompId?: number) {
    const mctId = multiCompId || this.currentSeasonId;

    this.flightService.addMCTSponsorClickCount(mctId, sponsorId).subscribe(
      (data: any) => {
        console.debug('add mct sponsor click count: ');
      },
      error => {}
    );
  }

  participatingClubs: BehaviorSubject<any> = new BehaviorSubject(null);

  setParticipatingClubs(value: any) {
    this.participatingClubs.next(value);
  }
  getParticipatingClubs() {
    return this.participatingClubs.asObservable();
  }
  refreshParticipatingClubs(multiCompId?: number) {
    const mctId = multiCompId || this.currentSeasonId;
    this.flightService.getMCTParticipatingClubs(mctId).subscribe(
      (participatingClubs: any[]) => {
        console.debug('get mct prizes: ', participatingClubs);
        if (participatingClubs?.length) this.setParticipatingClubs(participatingClubs);
        else this.setParticipatingClubs(null);
      },
      error => {
        this.setParticipatingClubs(null);
      }
    );
  }

  multiCourseRounds: BehaviorSubject<any> = new BehaviorSubject(null);
  setMultiCourseRounds(value: any) {
    this.multiCourseRounds.next(value);
  }

  getMultiCourseRounds() {
    return this.multiCourseRounds.asObservable();
  }

  getRounds(leagueSeason?: LeagueSeason) {
    let _orgId = leagueSeason?.league?.organizer?.id || this.currentOrganizerId; // this.leagueSeasonDetails? .league?.organizer?.id;
    let _seasonId = leagueSeason?.id || this.currentSeasonId;
    this.flightService
      .getMultiCourseCompRounds(_orgId, _seasonId)
      .subscribe((leagueRounds: Array<LeagueSeasonCompetitionView>) => {
        if (leagueRounds?.length) {
          this.setMultiCourseRounds(leagueRounds);

          // let navigationExtras: NavigationExtras = {
          //   state: {
          //     seasonId: this.currentSeasonId,
          //     leagueSeason: this.leagueSeason,
          //     competitionRounds: this.multiCourseRounds,
          //   },
          // };
          // this.router.navigate(['tabs/multi-course-competition-rounds'], navigationExtras);
        }
      });
  }

  playerActiveRound: BehaviorSubject<any> = new BehaviorSubject(null);

  getPlayerActiveRound() {
    return this.playerActiveRound.asObservable();
  }

  setPlayerActiveRound(value) {
    this.playerActiveRound.next(value);
  }

  refreshPlayerActiveRound() {
    let _player;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });

    let params = {
      playerId: _player?.playerId || _player?.id,
      asOf: moment().format('YYYY-MM-DD'),
    };
    this.flightService.getMCTPlayerActiveRound(params).subscribe(data => {
      this.setPlayerActiveRound(data);
    });
  }
}
